import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { useLazyProfileQuery } from "../../../redux/api/user/userAPI";
import { selectAuth } from "../../../redux/features/auth/auth-slice";
import { selectProfile } from "../../../redux/features/user/user-slice";
import { getConsumerPrivateRoutes } from "../../../screens/routes";
import { UserRole } from "../../oversight-core/enums/user-roles";
import { AppRoute } from "../../oversight-core/interfaces/app-routes";
import { IHttpError } from "../../oversight-core/interfaces/http-errror";
import SpinnerModal from "../../oversight-core/ui-elements/spinner/spinner";
import isEmailVerified from "../../oversight-core/utils/isEmailVerified";

const PublicRoute = () => {
  const navigate = useNavigate();
  const auth = useSelector(selectAuth);
  const profile = useSelector(selectProfile);
  const [getProfile, { isFetching, isLoading }] = useLazyProfileQuery();

  const redirectToDashboard = useCallback(
    (userRole?: UserRole) => {
      const subRoutes = getConsumerPrivateRoutes(userRole).find(
        (route) => route.root,
      )?.subRoutes;

      const indexedRoute = subRoutes?.find((route) => route.index);
      const firstAllowedRoute = subRoutes?.find(
        (route) =>
          route.path !== AppRoute.NOT_FOUND && !route.path.includes(":"),
      );

      const path =
        indexedRoute?.path ?? firstAllowedRoute?.path ?? AppRoute.DASHBOARD;

      navigate(path, { replace: true });
    },
    [navigate],
  );

  useEffect(() => {
    if (!auth.token) {
      return;
    }

    if (profile) {
      redirectToDashboard(profile.role);
      return;
    }

    getProfile()
      .unwrap()
      .then((data) => {
        redirectToDashboard(data.role);
      })
      .catch((error: IHttpError) => {
        if (isEmailVerified(error)) {
          // navigate to verify email page , enter the email
        }
      });
  }, [auth.token, profile, getProfile, redirectToDashboard]);

  return (
    <div className="bg-background">
      {!isFetching && !isLoading && <Outlet />}
      <SpinnerModal show={isLoading || isFetching} />
    </div>
  );
};

export default PublicRoute;
